import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, Transition as _Transition, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "py-10 text-center w-full"
};
const _hoisted_2 = {
    key: 1,
    class: "flex w-full flex-col gap-3"
};
const _hoisted_3 = { key: 0 };
const _hoisted_4 = { class: "my-8" };
const _hoisted_5 = { class: "font-semibold mb-4 text-sm" };
const _hoisted_6 = { class: "m-0 p-0" };
const _hoisted_7 = { class: "flex items-center justify-end gap-4" };
import { computed, reactive, ref } from 'vue';
import { useUsuariosStore } from '@/stores';
import { toast } from '@/common/util';
import { useI18n } from 'vue-i18n';
import UsuariosService from '@/services/usuarios.service';
import UiInput from '@/components/ui/input.vue';
import UiButton from '@/components/ui/button.vue';
import UiForm from '@/components/ui/form.vue';
import UiFormControl from '@/components/ui/formControl.vue';
import UiModal from '@/components/ui/modal.vue';
import UiIcon from '@/components/ui/icon.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'modalChangePassword',
    setup(__props, { expose: __expose }) {
        const { t } = useI18n();
        const defaultValues = {
            password: '',
            confirmPassword: ''
        };
        const modal = ref();
        const form = reactive({ ...defaultValues });
        const user = ref();
        const formRef = ref();
        const busy = ref(false);
        const validation = computed(() => {
            if (!formRef.value?.result.$dirty)
                return {
                    length: '',
                    hasLetters: '',
                    case: '',
                    hasNumbers: '',
                    hasSpecialChars: '',
                    match: ''
                };
            const { password, confirmPassword } = formRef.value?.result || {};
            const pwErrors = getFormatedErrors(password?.$errors);
            const cpwErros = getFormatedErrors(confirmPassword?.$errors);
            return {
                length: isValid(pwErrors.minMax),
                hasLetters: isValid(pwErrors.letters),
                case: isValid(pwErrors.case),
                hasNumbers: isValid(pwErrors.numbers),
                hasSpecialChars: isValid(pwErrors.specialChars),
                match: isValid(cpwErros.match)
            };
        });
        const rules = ref({
            password: [{
                    name: 'required',
                    test: (value) => value.length,
                    message: () => t('validation.required')
                }, {
                    name: 'minMax',
                    test: (value) => value.length >= 8 && value.length <= 20,
                    message: () => t('newPassword.validation.minMax', { min: 8, max: 20 })
                }, {
                    name: 'letters',
                    test: (value) => value.match(/[a-z]/i),
                    message: () => t('newPassword.validation.letters')
                }, {
                    name: 'case',
                    test: (value) => value.match(/[A-Z]/),
                    message: () => t('newPassword.validation.case')
                }, {
                    name: 'numbers',
                    test: (value) => value.match(/[0-9]/),
                    message: () => t('newPassword.validation.numbers')
                }, {
                    name: 'specialChars',
                    test: (value) => value.match(/[!@#$%^&*(),.?":{}|<>]/),
                    message: () => t('newPassword.validation.specialChars')
                }],
            confirmPassword: [{
                    name: 'required',
                    test: (value) => value.length,
                    message: () => t('placeholder.confirmPassword')
                }, {
                    name: 'match',
                    test: (value) => value.length && value === form.password,
                    message: () => t('validation.passwordMatch')
                }]
        });
        const usuariosStore = useUsuariosStore();
        const isValid = (test) => !test ? 'valid' : 'invalid';
        const getFormatedErrors = (err) => (err?.reduce((acc, e) => {
            acc[e.name] = e.message;
            return acc;
        }, {}) || {});
        const submit = async () => {
            if (!formRef.value.validate()) {
                return toast.error({
                    title: t('dialogs.ops'),
                    message: t('feedback.formError')
                });
            }
            busy.value = true;
            try {
                const { success } = await UsuariosService.changePassword({
                    userId: user.value.id,
                    email: user.value.email,
                    password: form.password
                });
                if (success) {
                    close();
                    return toast.success({ message: t('toasts.users.updatedPassword') });
                }
            }
            catch (error) {
                //
            }
            finally {
                busy.value = false;
            }
        };
        const open = async (opt) => {
            reset();
            await modal.value?.open();
            if (typeof opt === 'string') {
                user.value = await usuariosStore.getById(opt);
                if (!user.value?.id) {
                    return toast.error({
                        message: t('feedback.errorLoadObject', { object: t('labels.user').toLowerCase() })
                    });
                }
            }
            else if (typeof opt === 'object') {
                // @ts-ignore
                user.value = opt;
            }
        };
        const close = () => {
            reset();
            modal.value?.cancel();
        };
        const reset = () => {
            Object.assign(form, { ...defaultValues });
            user.value = null;
        };
        __expose({
            open,
            close,
            reset
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(UiModal, {
                ref_key: "modal",
                ref: modal,
                title: _ctx.$t('modals.newPassword'),
                width: "550px",
                loading: _unref(usuariosStore).loading
            }, {
                footer: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                        _createVNode(UiButton, {
                            type: "danger",
                            outline: "",
                            class: "px-6 py-3 text-sm uppercase outline-[1px]",
                            onClick: close
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('button.cancel')), 1)
                            ]),
                            _: 1
                        }),
                        _createVNode(UiButton, {
                            type: "primary",
                            disabled: form.password.length === 0 || formRef.value?.result.$invalid,
                            loading: _unref(usuariosStore).loading || busy.value,
                            class: "px-6 py-3 text-sm uppercase",
                            onClick: submit
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('button.confirm')), 1)
                            ]),
                            _: 1
                        }, 8, ["disabled", "loading"])
                    ])
                ]),
                default: _withCtx(() => [
                    (_unref(usuariosStore).loading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            _createVNode(UiIcon, {
                                class: "animate-spin",
                                icon: "loader"
                            }),
                            _createTextVNode(" " + _toDisplayString(_unref(t)('feedback.loading')), 1)
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createElementVNode("div", null, [
                                _createElementVNode("strong", null, _toDisplayString(_unref(t)('column.name')) + ":", 1),
                                _createTextVNode(" " + _toDisplayString(user.value?.nomeCompleto), 1)
                            ]),
                            (user.value?.cpf)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                    _createElementVNode("strong", null, _toDisplayString(_unref(t)('input.document')) + ":", 1),
                                    _createTextVNode(" " + _toDisplayString(user.value?.cpf), 1)
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", null, [
                                _createElementVNode("strong", null, _toDisplayString(_unref(t)('input.email')) + ":", 1),
                                _createTextVNode(" " + _toDisplayString(user.value?.email), 1)
                            ])
                        ])),
                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "w-full rounded-md border border-solid border-[#EEEFF1] dark:border-[#79767A]" }, null, -1)),
                    _createVNode(UiForm, {
                        ref_key: "formRef",
                        ref: formRef,
                        "auto-validate": "",
                        disabled: _unref(usuariosStore).loading,
                        "form-data": form,
                        rules: rules.value
                    }, {
                        default: _withCtx(() => [
                            _createVNode(UiFormControl, {
                                label: _ctx.$t('newPassword.title'),
                                prop: "password",
                                class: "mb-5 w-full"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(UiInput, {
                                        modelValue: form.password,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((form.password) = $event)),
                                        type: "password",
                                        togglePassword: "",
                                        id: "password",
                                        placeholder: _ctx.$t('placeholder.newPassword'),
                                        class: "w-full"
                                    }, null, 8, ["modelValue", "placeholder"])
                                ]),
                                _: 1
                            }, 8, ["label"]),
                            _createVNode(UiFormControl, {
                                label: _ctx.$t('placeholder.confirmPassword'),
                                prop: "confirmPassword",
                                class: "w-full"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(UiInput, {
                                        modelValue: form.confirmPassword,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((form.confirmPassword) = $event)),
                                        id: "confirmPassword",
                                        togglePassword: "",
                                        type: "password",
                                        placeholder: _ctx.$t('placeholder.confirmPassword'),
                                        class: "w-full"
                                    }, null, 8, ["modelValue", "placeholder"])
                                ]),
                                _: 1
                            }, 8, ["label"]),
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(t)('newPassword.rulesText')) + ":", 1),
                                _createElementVNode("ul", _hoisted_6, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([
                                        ['length', _unref(t)('newPassword.rules.length', { min: 8, max: 20 })],
                                        ['hasLetters', _unref(t)('newPassword.rules.hasLetters')],
                                        ['case', _unref(t)('newPassword.rules.case')],
                                        ['hasNumbers', _unref(t)('newPassword.rules.hasNumbers')],
                                        ['hasSpecialChars', _unref(t)('newPassword.rules.hasSpecialChars')],
                                        ['match', _unref(t)('newPassword.rules.match')]
                                    ], (rule) => {
                                        return (_openBlock(), _createElementBlock("li", {
                                            key: rule[0],
                                            class: _normalizeClass(["text-sm font-medium mb-.5 transition duration-300", {
                                                    'text-[#17AC6C]': validation.value[rule[0]] === 'valid',
                                                    'text-[#FF4980]': validation.value[rule[0]] === 'invalid'
                                                }])
                                        }, [
                                            _createVNode(_Transition, {
                                                mode: "out-in",
                                                "enter-active-class": "transition transform",
                                                "enter-from-class": "opacity-0 scale-0",
                                                "leave-active-class": "transition transform",
                                                "leave-to-class": "opacity-0 scale-0"
                                            }, {
                                                default: _withCtx(() => [
                                                    (validation.value[rule[0]] === 'valid')
                                                        ? (_openBlock(), _createBlock(UiIcon, {
                                                            key: 0,
                                                            size: "20",
                                                            icon: "circle-check"
                                                        }))
                                                        : (validation.value[rule[0]] === 'invalid')
                                                            ? (_openBlock(), _createBlock(UiIcon, {
                                                                key: 1,
                                                                size: "20",
                                                                icon: "circle-x"
                                                            }))
                                                            : _createCommentVNode("", true)
                                                ]),
                                                _: 2
                                            }, 1024),
                                            _createTextVNode(" " + _toDisplayString(rule[1]), 1)
                                        ], 2));
                                    }), 128))
                                ])
                            ])
                        ]),
                        _: 1
                    }, 8, ["disabled", "form-data", "rules"])
                ]),
                _: 1,
                __: [2]
            }, 8, ["title", "loading"]));
        };
    }
});
